export const StringToDate = function (strDate: string) {
    var date = new Date();
    var hours = strDate.split(":")[0];
    var minutes = strDate.split(":")[1];
    var seconds = strDate.split(":")[2];
    date.setHours(+hours);
    date.setMinutes(+minutes);
    date.setSeconds(+seconds);
    return date.toISOString() !== '' ? date : '';
}